import React from "react";
import { OutOfOfficeLoadWarning } from "./Core/Common/Constants";
import { ExchangeIcon } from "./assets/images/svg/ProductLogoCollection";

const OutOfOffice: React.FC = () => {
    return (
        <div className="loading-screen-container">
            <ExchangeIcon height={51} width={230} />
            <h3 className="center text-center">
                <br />
                {OutOfOfficeLoadWarning}
            </h3>
        </div>
    );
};

export default OutOfOffice;
